import * as models from '../../../shared/model/api/AuthData';
import * as authDataActions from '../actions/auth-data.action';
import { ViewConstants } from '../../../constants';
import { createReducer, on } from '@ngrx/store';
export interface AuthDataState {
    AuthData: models.AuthData;
}
const initialState: AuthDataState = {
     AuthData : { originalURLAccessed : ViewConstants.EMPTY_STRING, user: null}
};
export const reducer = createReducer(
    initialState,
    on(authDataActions.SetOriginalURLAccessedAction, (state, action) => {
        return {...state, AuthData:{...state.AuthData, originalURLAccessed: action.payload}};
    }),
    on(authDataActions.SetLoggedInUserDataAction, (state, action) => {
        return {...state, AuthData:{...state.AuthData, user: action.payload as models.User }};
    }),
);

 

